import { render, staticRenderFns } from "./SiteNotes.vue?vue&type=template&id=ec0ebd18"
import script from "./SiteNotes.vue?vue&type=script&lang=js"
export * from "./SiteNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports